import { WidgetVerification } from "@/types/frontend";
import localStorage from "local-storage-fallback";

const STORAGE_KEY = "age_verification_result";

export default class VerificationStorage {
    public static get(): WidgetVerification | null {
        const storage: string | null = localStorage.getItem(STORAGE_KEY) || null;
        return storage ? JSON.parse(storage) as WidgetVerification : null;
    }

    public static set(data: WidgetVerification) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }

    public static clear(): void {
        localStorage.removeItem(STORAGE_KEY);
    }
}
